import { getTimeZones } from '@vvo/tzdb';

export interface TimezoneOption {
  label: string;
  value: string;
}

let cachedTimezoneOptions: TimezoneOption[] | undefined;

export const getTimezoneOptions = (): TimezoneOption[] => {
  cachedTimezoneOptions ??= getTimeZones().map((timezone) => {
    const [offset] = timezone.currentTimeFormat.split(' ');
    return {
      label: `(GMT${offset}) ${timezone.name}`,
      value: timezone.name,
    };
  });
  return cachedTimezoneOptions;
};
